import { useQuery as N } from "../../../node_modules/@tanstack/react-query/build/modern/useQuery.mjs";
import { useQueryClient as _ } from "../../../node_modules/@tanstack/react-query/build/modern/QueryClientProvider.mjs";
import { useInfiniteQuery as S } from "../../../node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.mjs";
import { COMMON_DATA_FILES_API_BASE_PATH as Y, DATA_FILES_API_BASE_PATH as v } from "../../file-uploader/api/index.mjs";
import { PaginationOrderEnum as R } from "../../../enums/pagination-enums.mjs";
import { httpClient as O } from "../../../utils/http-client.mjs";
const $ = async ({
  startFrom: m,
  limit: o,
  order: s,
  sortColumn: c,
  sortDirection: i,
  filter: e,
  fileManagerApiType: r
}) => {
  var C, u;
  const I = () => r != null && r.isCommon ? Y : v;
  return (await O.get(
    I() + "?" + (e != null && e.name ? `&filter[names][]=${e == null ? void 0 : e.name}` : "") + ((C = e == null ? void 0 : e.source) != null && C.length ? e.source.map((d) => `&filter[sources][]=${encodeURIComponent(d)}`).join("") : "") + ((u = e == null ? void 0 : e.type) != null && u.length ? e.type.map((d) => `&filter[types][]=${encodeURIComponent(d)}`).join("") : "") + (m ? `&pagination[startFrom]=${m}` : "") + (c ? `&pagination[sortColumn]=${c}` : "") + (i ? `&pagination[sortDirection]=${i}` : "") + (o ? `&pagination[limit]=${o}` : "") + (s ? `&pagination[order]=${s}` : "")
  )).data;
}, H = ({
  startFrom: m,
  limit: o = 10,
  order: s = R.Next,
  sortColumn: c,
  sortDirection: i,
  filter: e,
  fileManagerApiType: r
}, I) => {
  const a = _(), u = r != null && r.isCommon ? "common-data-files" : r != null && r.isPublic ? "public-data-files" : "data-files", d = [u], K = [
    u,
    { startFrom: m, limit: o, order: s, sortColumn: c, sortDirection: i, filter: e }
  ];
  return {
    ...N({
      queryKey: K,
      queryFn: () => $({ startFrom: m, limit: o, order: s, sortColumn: c, sortDirection: i, filter: e, fileManagerApiType: r }),
      ...I
    }),
    resetAndRefetch: () => {
      a.invalidateQueries({ queryKey: d });
    },
    triggerFetch: () => {
      a.fetchQuery({ queryKey: K });
    },
    deleteItemFromData: (h) => {
      a.getQueryCache().findAll({ queryKey: d }).forEach((P) => {
        a.setQueryData(
          P.queryKey,
          (q) => {
            if (q)
              return {
                ...q,
                items: q.items.filter((F) => F.id !== h)
              };
          }
        );
      });
    },
    renameItemFromData: ({ id: h, name: Q }) => {
      a.getQueryCache().findAll({ queryKey: d }).forEach((q) => {
        a.setQueryData(
          q.queryKey,
          (F) => {
            if (F)
              return {
                ...F,
                items: F.items.map((E) => E.id === h ? { ...E, name: Q } : E)
              };
          }
        );
      });
    }
  };
}, J = ({
  limit: m = 10,
  order: o = R.Next,
  sortColumn: s,
  sortDirection: c,
  filter: i,
  fileManagerApiType: e
}, r) => {
  const I = _(), u = [e != null && e.isCommon ? "common-infinite-data-files" : e != null && e.isPublic ? "public-infinite-data-files" : "infinite-data-files", { limit: m, order: o, sortColumn: s, sortDirection: c, filter: i }];
  return { ...S({
    initialPageParam: void 0,
    queryKey: u,
    queryFn: ({ pageParam: n }) => $({
      startFrom: typeof n == "string" ? n : void 0,
      limit: m,
      order: o,
      sortColumn: s,
      sortDirection: c,
      filter: i,
      fileManagerApiType: e
    }),
    getPreviousPageParam: (n) => {
      if (!n.hasMore) return;
      const t = n.items[0];
      if (t)
        return encodeURIComponent(
          JSON.stringify({
            id: t.id,
            field: t[s ?? "name"]
          })
        );
    },
    getNextPageParam: (n) => {
      if (!n.hasMore) return;
      const t = n.items[n.items.length - 1];
      if (t)
        return encodeURIComponent(
          JSON.stringify({
            id: t.id,
            field: t[s ?? "name"]
          })
        );
    },
    ...r
  }), resetAndRefetch: () => {
    I.invalidateQueries({ queryKey: u });
  }, deleteItemFromData: (n) => {
    I.setQueryData(u, (t) => t && {
      ...t,
      pages: t.pages.map((y) => ({
        ...y,
        items: y.items.filter((h) => h.id !== n)
      }))
    });
  }, renameItemFromData: ({ id: n, name: t }) => {
    I.setQueryData(u, (y) => y && {
      ...y,
      pages: y.pages.map((h) => ({
        ...h,
        items: h.items.map((Q) => Q.id === n ? { ...Q, name: t } : Q)
      }))
    });
  } };
};
export {
  H as useDataFiles,
  J as useInfiniteDataFiles
};
